import { useCallback } from 'react';
import { IErrorResponse } from 'src/utilities/shared-types';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { executeCorporateSetup } from 'src/components/enterprise/features/Corporate/CreatePage/functions/corporateSetup';
import { createCorporateModel } from 'src/components/enterprise/features/Corporate/utils/corporate.utilities';
import { transformCateringServiceFeeUIToModel } from 'src/components/enterprise/features/Corporate/components/Form/CateringServiceFeeControl/cateringServiceFeeControl.utils';
import { CreateCorpResponse } from 'src/types/Corp';

export type UseCreateParentCorpReturnType = {
  createParentCorp: (values: CorporateFormFields) => Promise<void>;
};

export type UseCreateParentCorpProps = {
  onSuccess: (corpData: CreateCorpResponse) => Promise<void>;
  onError: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
};

export const useCreateParentCorporate = ({
  onSuccess,
  onError,
}: UseCreateParentCorpProps): UseCreateParentCorpReturnType => {
  const createParentCorpTrigger = useCallback(
    async (values: CorporateFormFields) => {
      const { cateringServiceFee, ...corporateFormData } = values;
      const corporatePayload = {
        ...createCorporateModel(corporateFormData),
        childAccountsEnabled: true,
      };
      const cateringServiceFeePayload =
        transformCateringServiceFeeUIToModel(cateringServiceFee);

      try {
        const { corpData } = await executeCorporateSetup(
          corporatePayload,
          cateringServiceFeePayload,
          values.universalAccountsEnabled
        );
        await onSuccess(corpData);
      } catch (error) {
        await onError(error);
      }
    },
    [onSuccess, onError]
  );

  return {
    createParentCorp: createParentCorpTrigger,
  };
};
